import { createGenericQuery, getGenericQueryKey } from 'js/react_query_helpers/helpers';
const rpcName = 'previews:get_preview_data_batch';
export const createPreviewMetadataQueryKey = getGenericQueryKey('custom', rpcName, (arg) => {
    return {
        // If we have a shared link URL for the file, that's enough to identify it uniquely. File Viewer can be
        // initialized with a shared link as the only identifier for a file. In those cases, this query will fetch and
        // populate the file ID and other file metadata. We want to only use the URL in the queryKey to avoid refetching
        // when those fields are populated.
        files: arg.files.map((file) => { var _a; return (_a = file.url) !== null && _a !== void 0 ? _a : file; }),
        include_dimensions: arg.include_dimensions,
    };
});
export const makePreviewMetadataRequestPackage = (previewsGetPreviewDataBatch) => createGenericQuery({
    queryRouteFilter: ['custom', rpcName],
    queryFn: ({ apiArg }) => async ({}) => {
        if (
        // Legacy paper docs have an invalid file_id format as a shim to get
        // them into a browse file like state.  This breaks the APIv2 call at
        // the deserialization level since the API spec specifies the id
        // should start with `id:`.  We should be OK to remove this if the
        // PIFS migration ever finishes.
        apiArg.files.length === 1 &&
            apiArg.files[0].file_id &&
            !apiArg.files[0].file_id.startsWith('id:')) {
            throw new Error('Invalid file_id format');
        }
        const result = await previewsGetPreviewDataBatch(apiArg, {});
        // TODO: Consider throwing result.results[0].error if it exists.
        return {
            apiData: result,
            pkgData: null,
        };
    },
    getQueryKey: createPreviewMetadataQueryKey,
});
//# sourceMappingURL=preview_metadata.preenvesnextjs.map
